import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { simples } from '../../modulos/validation/simples.js';
import { cpf } from '../../modulos/validation/cpf.js';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import InputMask from 'react-input-mask';
import logo from '../../assets/GrupoZelo_horizontal.jpg';
import { Growl } from 'primereact/growl.js';
import AccessService from '../../services/access/index';
import { criptObjectOnLocalStorage, criptoLocalStorage } from '../../modulos/cripotografia/criptoStorage.js';

export default class Acesso extends Component {
    constructor() {
        super();

        this.state = {
            codigo: '',
            cpf: '',
            erroForm: '',
            loading: 'loading',
            submit: false,
            selectedTipo: {},
            rota: ''
        };

        this.tipos = [
            // {
            //     name: 'Vendedor',
            //     code: 1
            // },
            // {
            //     name: 'Colaborador',
            //     code: 1
            // },
            // {
            //     name: 'Supervisor',
            //     code: 3
            // },
            // {
            //     name: 'Coordenador',
            //     code: 2
            // },
            {
                name: 'Analista',
                code: 7
            },
            {
                name: 'Gerente',
                code: 8
            }
        ];
    }

    handleSubmit = async e => {
        try {
            e.preventDefault();
            this.setState({
                loading: 'nada',
                submit: true
            });

            const permissao = this.state.selectedTipo.code;
            const codigo = this.state.codigo;
            const CPF = this.state.cpf;

            const verificaCodigo = simples(codigo);
            const verificaCPF = cpf(CPF);

            if (verificaCodigo.value === false) {
                throw new Error(verificaCodigo.mess);
            }

            if (verificaCPF.value === false) {
                throw new Error(verificaCPF.mess);
            }

            const verificaHierarquiaCorreta = await AccessService.accessHierarquia(permissao, CPF);

            if(verificaHierarquiaCorreta?.message){
                throw new Error(verificaHierarquiaCorreta.message);
            }

            let rota = '';

            switch (permissao) {
                case 1:
                    rota =  '/access-vendedor';
                    break;
                case 2:
                    rota =  '/access-coordenador';
                    break;
                case 3:
                    rota =  '/access-supervisor';
                    break;
                case 7:
                    rota =  '/access-analista';
                    break;
                case 8:
                    rota =  '/access-gerente';
                    break;
                default:
                    throw new Error('Selecione um tipo de perfil!');
            }

            this.setState({ loading: true });

            const response = await AccessService.primeiroAcesso(rota, codigo, CPF);

            if(!response || !response.length){
                throw new Error(`Não foi encontrado perfil de ${this.state.selectedTipo.name} para as informações passadas!`);
            }

            if (!response[0].CPF) {
                throw new Error('Dados Não conferem');
            }

            criptObjectOnLocalStorage('tipoPermissao', this.state.selectedTipo.code);
            criptoLocalStorage('codigo', response[0].codigo);
            criptoLocalStorage('cpf', response[0].CPF);
            this.showSuccess('Informações validadas! Vooê será redirecionado');
            setTimeout(()=>{
                this.props.history.push('/criar-acesso');
                window.location.reload();
            },1000);
        } catch (error) {
            console.log(error);
            this.showError(error.message);
        } finally {
            this.setState({
                loading: 'loading',
                submit: false
            });
        }
    }

    handleCodigo = e => {
        this.setState({ codigo: e.target.value });
    };

    handleCpf = e => {
        this.setState({ cpf: e.target.value });
    };

    showError = mess => {
        this.messages.show({
            sticky: false,
            summary: 'Erro',
            severity: 'error',
            detail: mess,
            life: 3000
        });
    };

    showSuccess = mess => {
        this.messages.show({
            sticky: false,
            summary: 'Sucesso',
            severity: 'success',
            detail: mess,
            life: 3000
        });
    };

    clear = () => {
        this.messages.clear();
    };

    onBlurCodigo = e => {
        if (simples(e.target.value).value === false) {
            this.showError(simples(e.target.value).mess);
        }
    };

    onBlurCpf = e => {
        if (cpf(e.target.value).value === false) {
            this.showError(cpf(e.target.value).mess);
        }
    };

    onTipoChange = e => {
        this.setState({ selectedTipo: e.value });
    };

    render() {
        return (
            <div className="login-content">
                <center>
                    <div className="login p-col-12 p-md-5 p-lg-4">
                        <form onSubmit={this.handleSubmit}>
                            <img className="logo-responsivo" src={logo}/>
                            <div className="p-float-label p-col-10">
                                <p>Obter Primeiro Acesso</p>
                                <span className="loading">
                                </span>

                            </div>
                            <div className="p-float-label p-col-10">
                                <InputText id="codigo" value={this.state.value} onBlur={this.onBlurCodigo} onChange={this.handleCodigo} name="codigo" placeholder="Seu Código" />
                            </div>

                            <div className="p-float-label p-col-10">
                                <InputMask mask="999.999.999-99" id="cpf"
                                    value={this.state.value} onBlur={this.onBlurCpf}
                                    onChange={this.handleCpf} name="cpf"
                                    placeholder="  Seu CPF"
                                    style={{ height: '35px' }}/>
                            </div>
                            <div className="p-float-label p-col-10">
                                <Dropdown value={this.state.selectedTipo} options={this.tipos} onChange={this.onTipoChange} optionLabel="name" placeholder="Selecione o Tipo" style={{ width: '100%' }}/>
                            </div>

                            <div className=" p-col-10">
                                <Growl ref={el => this.messages = el}></Growl>
                            </div>

                            <div className="entrar">
                                <Button label="Obter agora" type="submit" />
                            </div>
                            <div className={this.state.loading}>
                                <ProgressSpinner style={{
                                    width: '50px',
                                    height: '50px'
                                }} strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
                            </div>

                            <div className="link">
                                <a href="#/login">Ir para login</a>
                            </div>
                        </form>
                    </div>
                </center>
            </div>
        );
    }
}
